import type { GridOptions } from 'ag-grid-enterprise';

const { host } = window.location;
const isNonProductionAuth0Host =
  host.startsWith('localhost') ||
  host.startsWith('scope-qa') ||
  host.endsWith('.scope-preview.qa.pondurance.com');
const auth0Host = isNonProductionAuth0Host
  ? 'pondurance-dev.us.auth0.com'
  : 'pondurance.auth0.com';
const auth0ClientId = isNonProductionAuth0Host
  ? 'sKVri8lrEultuFo324CRojKdpaq11ytF'
  : 'waUaStrSjcGkF5dBUBfElMniXS6xKcYi';

export const AUTH0_HOST = auth0Host;
export const AUTH0_URL = `https://${auth0Host}`;
export const AUTH0_CLIENT_ID = auth0ClientId;
export const DOCS_URL = 'https://docs.pondurance.com';
export const LOGSCALE_URL = 'https://events.pondurance.com';
export const MYCYBERSCORECARD_URL =
  'https://pondurance.outsystemsenterprise.com/MyCyberScorecard';
export const PONDURANCE_URL = 'https://pondurance.com';
export const PONDURANCE_URL_WWW = 'https://www.pondurance.com';
export const SCOPE_URL = 'https://scope.pondurance.com';
export const TICKET_URL = 'https://scope.pondurance.com/ticket/';
export const DEV_URL = 'https://localhost:5173/';
export const AI_ANALYST_NAME = 'Kanati AI';
const DEV_HOST_FOR_INTERNAL_DOMAIN_REGEX = new URL(DEV_URL).host.replace(
  '.',
  '\\.'
);
const INTERNAL_DOMAIN_PATTERN = `^(http|https|ftp):\\/\\/((([a-zA-Z0-9-]+\\.)*pondurance\\.com)|(pondurance\\.auth0\\.com)|(pondurance-dev\\.us\\.auth0\\.com)|(pondurance\\.outsystemsenterprise\\.com)|(${DEV_HOST_FOR_INTERNAL_DOMAIN_REGEX}))(\\/.*)?$`;
export const INTERNAL_DOMAIN_REGEX = new RegExp(INTERNAL_DOMAIN_PATTERN, 'i');
export const ALL_URL_REGEX =
  /((http|https|ftp):\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/\S*)?/g;

export const ACCEPTED_FILES_CSV = [
  'application/vnd.ms-excel',
  'text/csv',
  '.csv'
];
export const ACCEPTED_FILES_EXCEL = [
  'application/vnd.ms-excel',
  'application/msexcel',
  'application/x-msexcel',
  'application/x-ms-excel',
  'application/x-excel',
  'application/x-dos_ms_excel',
  'application/xls',
  'application/x-xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  '.xls',
  '.xlsx'
];
export const ACCEPTED_FILES_IMAGE = [
  'image/bmp',
  'image/gif',
  'image/jpeg',
  'image/png',
  'image/svg+xml',
  'image/tiff'
];
export const ACCEPTED_FILES_PDF = [
  'application/pdf',
  'application/x-pdf',
  '.pdf'
];
export const ACCEPTED_FILES_POWERPOINT = [
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  '.ppt',
  '.pptx'
];
export const ACCEPTED_FILES_SURICATA = ['.config', '.rules'];
export const ACCEPTED_FILES_WORD = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.doc',
  '.docx'
];
export const ACCEPTED_FILES_JSON = ['application/json', '.json'];
export const ACCEPTED_FILES_MARKDOWN = [
  'text/markdown',
  'text/x-markdown',
  '.md',
  '.markdown'
];
export const ACCEPTED_FILES_TEXT = ['text/plain', '.txt'];
export const ACCEPTED_FILES_ZIP = [
  'application/x-zip',
  'application/x-zip-compressed',
  'application/zip',
  '.zip'
];

export const ALLOWED_URLS = [
  AUTH0_URL,
  DOCS_URL,
  LOGSCALE_URL,
  MYCYBERSCORECARD_URL,
  PONDURANCE_URL,
  PONDURANCE_URL_WWW,
  SCOPE_URL,
  DEV_URL
];

export enum PRIORITY {
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3',
  P4 = 'P4',
  P5 = 'P5'
}

export const PRIORITIES = [
  PRIORITY.P1,
  PRIORITY.P2,
  PRIORITY.P3,
  PRIORITY.P4,
  PRIORITY.P5
];

export const AUTH_ERROR_STORAGE_KEY = 'auth_error';
export const DEFAULT_GRID_PAGE_SIZE = 20;
export const DEFAULT_PAGE_SIZE = 25;
export const ENV_DEV = 'development';
export const ENV_QA = 'qa';
export const ENV_PROD = 'production';
export const ENV_STG = 'staging';
export const INCIDENT_RESPONSE_PHONE_NUMBER = '+1 (888) 385-1720';
export const INCIDENT_RESPONSE_PHONE_NUMBER_HREF = 'tel:+1-888-385-1720';
export const LAYOUT_BREAKPOINT = 'md';
export const PAGE_SIZES = [10, 25, 50, 100];
export const PONDURANCE_LABEL = 'ponhq';
export const PONDURANCE_NAME = 'Pondurance';
export const RULES_FILTERS_STORAGE_KEY = 'rulesFilters';
export const SHOW_TICKET_ALERT_STORAGE_KEY = 'hideTicketAlert';
export const SOC_EMAIL = 'soc@pondurance.com';
export const SOC_PHONE_NUMBER = '+1 (833) 854-3214';
export const SOC_PHONE_NUMBER_HREF = 'tel:+1-833-854-3214';
export const TICKET_DRAFT_STORAGE_KEY = 'draft';
export const TICKET_FILTERS_STORAGE_KEY = 'ticketFilters';
export const TICKET_TIME_FILTER_STORAGE_KEY = 'ticketTimeFilter';
export const ASSETS_FILTERS_STORAGE_KEY = 'assetsFilters';
export const ASSETS_TIME_FILTER_STORAGE_KEY = 'assetsTimeFilter';
export const CASES_FILTERS_STORAGE_KEY = 'casesFilters';
export const CASES_TIME_FILTER_STORAGE_KEY = 'casesTimeFilter';
export const INTERNAL_CASES_FILTERS_STORAGE_KEY = 'internalCasesFilters';
export const INTERNAL_CASES_TIME_FILTER_STORAGE_KEY = 'internalCasesTimeFilter';
export const ALERT_RULES_FILTERS_STORAGE_KEY = 'alertRulesFilters';
export const VULNERABILITIES_FILTERS_STORAGE_KEY = 'vulnerabilitiesFilters';
export const REMEDIATIONS_FILTERS_STORAGE_KEY = 'remediationsFilters';
export const VMP_TIME_FILTER_STORAGE_KEY = 'vmpTimeFilter';

export enum PERMISSIONS_LOGIC {
  AND = 'AND',
  OR = 'OR',
  NOT = 'NOT'
}

export const DEFAULT_GRID_SETTINGS: GridOptions = {
  paginationPageSize: 20,
  pagination: true,
  defaultColDef: {
    sortable: true,
    filter: false,
    resizable: true,
    suppressHeaderMenuButton: true
  },
  animateRows: false,
  suppressCellFocus: true,
  suppressMultiSort: true,
  tooltipShowMode: 'whenTruncated',
  suppressContextMenu: true
};

export const EXCLUDED_INTERNAL_ORGS = [
  'pontst',
  'demo1',
  'demo2',
  'ponsoc',
  'ponsup',
  'pondet'
];

export enum MUI_VARIANT_COLORS {
  DEFAULT = 'default',
  ERROR = 'error',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning'
}

// Organizations allowed for CRUD operations in QA and Staging environments
export const ALLOWED_ORGS_QA_STAGING = new Set([
  'pontst',
  'demo1',
  'demo2',
  'ponsup',
  'ir_mlstest1',
  'ir_mlstest2'
]);

export enum BOOL_LABELS {
  ENABLED = 'Enabled',
  DISABLED = 'Disabled',
  YES = 'Yes',
  NO = 'No',
  TRUE = 'true',
  FALSE = 'false',
  ON = 'On',
  OFF = 'Off'
}
